import { Group } from 'fabric/fabric-impl';
import { EventPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import { BasePlaceholder } from './base';

export class Event extends BasePlaceholder {
  create(props: EventPlaceholder) {
    let placeholder: Group | undefined = undefined;

    if (props.type === 'text') {
      placeholder = this.createTextPlaceholder(props);
    } else if (props.type === 'image') {
      placeholder = this.createImagePlaceholder(props);
    }

    if (!placeholder) {
      throw new Error('Unknown placeholder type');
    }

    this.canvas.add(placeholder);
    return placeholder;
  }
}
